<nz-modal [nzVisible]="showFieldMapperModal()" nzWidth="800px" nzTitle="Field Mapping"
  (nzOnCancel)="requestClose.emit()" (nzOnOk)="requestSave.emit(data)">
  <ng-container *nzModalContent>
    <p style="font-style: italic;">
      Match the color in your CSV file to QNE Accounting fields. This ensures that each data point is accurately aligned
      with the appropriate field, facilitating a smooth and organized data import process.
    </p>
    <form nz-form se-container="1" labelWidth="250px" nzLayout="vertical" #form="ngForm">
      <div class="grid-container">
        @for (column of columns(); track column; let i = $index) {
        @if (column.index !== 'id' && !column.noMapping) {
        <div class="grid-item">
          <se [label]="column.index">
            <nz-select [(ngModel)]="data[column?.index]" [nzOptions]="csvSelectOptions()" nzAllowClear
              name="{{column?.index}}" nzSize="default">
            </nz-select>
          </se>
        </div>
        }
        }
      </div>
    </form>
  </ng-container>
</nz-modal>
